import { oldApiInstance } from 'functions/request';

const endpoint = '/user/tutorial_state/dashboard';

export const getOnboardingState = () => oldApiInstance.get(endpoint);
